import { DropdownType } from '@models/customForm';

interface IndustryModuleMapper {
    [key: string]: DropdownType;
}

export const industryModuleMapper: IndustryModuleMapper = {
    'Accommodations, Leisure, and Recreation': DropdownType.Hospitality,
    'Construction and Specialty Trades': DropdownType.Construction,
    'Educational Services': DropdownType.Education,
    'Finance, Real Estate, Rental, and Insurance': DropdownType.Finance,
    'Health Care and Social Assistance': DropdownType.Healthcare,
    'Manufacturing, Retail and Wholesale Trade': DropdownType.Commerce,
    'Media, Entertainment, and Technology': DropdownType.Entertainment,
    'Natural Resources, Agriculture, and Utilities': DropdownType.Utilities,
    'Professional, Administrative, and Consumer Services': DropdownType.AdminService,
    'Public Administration and Waste Management': DropdownType.Government,
    'Transportation and Warehousing': DropdownType.Transportation,
};

export function getSubindustryDropdownType(industry: string): DropdownType {
    return industryModuleMapper[industry];
}
